import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import { StorageServices } from '@/services/StorageServices';
import network from '@/views/network';
import village from '@/views/village';
import begin from '@/views/begin';
import villages from '@/views/villages';
import interlude from '@/views/interlude';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'root',
        children: [
            ...begin.routes(),
            ...village.routes(),
            ...villages.routes(),
            ...network.routes(),
            ...interlude.routes(),
        ],
    },
    {
        path: '/icons',
        component: () => import("@/views/iconsCheatSheet.vue"),
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        let scroller = document.querySelector('.appPageContainer');
        if(!scroller)
            return;

        if(savedPosition)
            return savedPosition;
        else
            scroller.scrollTop = 0;
    }
})

router.beforeEach((to, from, next) => {

    if(store.state.beforeNavCbs.length == 0)
        next();
    store.state.beforeNavCbs.forEach(x => {
        x(to, from, next);
    });
    store.state.beforeNavCbs = [];
    
})

router.afterEach((to, from) => {
    store.state.afterNavCbs.forEach(x => {
        x(to, from);
    });
    store.state.afterNavCbs = [];
})

export default router
